import { FlexiButton } from "@flexinet/ui-components";
import { MdRestoreFromTrash } from "react-icons/md";
import { Message, MessageStatus } from "../types";

interface RestoreButtonProps {
    record: Message;
    onClick: (record: Message) => void;
}

export const RestoreButton = ({ record, onClick }: RestoreButtonProps) => {
    return (
        <FlexiButton 
            variant={'outline'} 
            onClick={() => onClick({ ...record, status: MessageStatus.UNREAD })}
            leftSection={<MdRestoreFromTrash />}
        >
            Restore
        </FlexiButton>
    );
};
